import React, { useState } from 'react';
import { Box, Input, Modal } from 'native-base';
import { useI18n, useSpringBigStore, useUpdateMember, validateEmail } from '@springbig/shared';
import { useGeneralStyles, useModalStyles } from '../../../shared/styles';
import { Caption, H3 } from '~/shared/Typography';
import { useToast } from '~/hooks/toast';
import dayjs from 'dayjs';
import Button from '~/shared/Button';

export type AutoConnectFieldType = 8 | 10;

type ConditionalFormType = {
    isOpen: boolean;
    closeModal: () => void;
    fieldType: AutoConnectFieldType;
}



const ConditionalForm = ({ fieldType, isOpen, closeModal }: ConditionalFormType) => {

    const [email, setEmail] = useState('');
    const [birthday, setBirthday] = useState(dayjs(new Date()).format('YYYY-MM-YY'));
    const { mutate: updateMember, isLoading } = useUpdateMember();
    const gStyles = useGeneralStyles();
    const { t } = useI18n();
    const { errorToast } = useToast();

    const {
        text,
        background,
        header_background,
        body_background,
        footer_background,
    } = useModalStyles();

    const handleFormSubmit = () => {
        if (fieldType === 10) {
            const isEmailValid = validateEmail(email);
            if (isEmailValid) {
                updateMember({
                    member: {
                        email
                    }
                });
                closeModal();
            }
            else {
                errorToast(t('errors.invalid_email'));
            }
        }
        else if (fieldType === 8) {


            const today = new Date().toISOString().slice(0, 10); // Get today's date in "yyyy-mm-dd" format

            if (birthday < today) {
                updateMember({
                    member: {
                        birthday
                    }
                });
                closeModal();
            }
            else {
                errorToast(t('errors.birthday_in_past'));
                setBirthday('');
            }

        }
    };

    return (
        <Modal isOpen={isOpen} >
            <Modal.Content
                bg={background}
                maxWidth="400px"
            >

                <Modal.Header
                    bg={header_background}
                    textAlign={'center'}
                    paddingRight={20}
                    borderBottomColor={gStyles.divider}
                >
                    <H3
                        color={text}
                        textTransform={'capitalize'}
                    >
                        {`${t('general.update')} ${fieldType === 8 ? t('general.birthday') : t('general.email')}`}
                    </H3>
                </Modal.Header>
                {fieldType === 8 && (
                    <Box bg={body_background} width={'100%'} alignContent={'center'} p={8}>
                        <input
                            style={{ height: '28px', paddingLeft: '10px', paddingRight: '10px' }}
                            type="date"
                            value={birthday}
                            onChange={e => setBirthday(e.target.value)}
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                            required
                            max={birthday}
                        />
                    </Box>
                )}

                {fieldType === 10 && (
                    <Box px={2} py={2}>
                        <Caption text='general.update' />
                        <Input
                            onChangeText={(text: string) => setEmail(text)}
                            value={email}
                            keyboardType="email-address"
                            placeholder={t('general.email_example')}
                        />
                    </Box>
                )}

                <Modal.Footer
                    bg={footer_background}
                >
                    <Button
                        variant="ghost"
                        bg={gStyles.button_danger_background}
                        _text={{
                            color: gStyles.button_danger_text,
                        }}
                        onPress={closeModal}
                    >
                        {t('general.cancel')}
                    </Button>
                    <Button
                        bg={gStyles.button_background}
                        _text={{
                            color: gStyles.button_text,
                            textTransform: 'capitalize'
                        }}
                        onPress={handleFormSubmit}
                        isDisabled={isLoading}
                    >
                        {t('general.update')}
                    </Button>
                </Modal.Footer>
            </Modal.Content>
        </Modal>
    );

};

export default ConditionalForm;
